/**
 * this file contains services initiation, and exports singeltons
 */

import Api from './Api';
import Auth from './Auth';
import _socket from './Socket';

export const api = new Api();
export const authService = new Auth();
export const socket = _socket;



// WEBPACK FOOTER //
// ./src/services/index.js